import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Logo } from './styles';

function BrandLogo({ slug, width }) {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [slug]);

  return (
    <div>
      {!isError ? (
        <Logo
          src={`/images/brandLogo/${slug}.svg`}
          width={width}
          height={width}
          onError={setIsError}
        />
      ) : (
        <Logo
          src="/images/brandLogo/brand-generic.svg"
          width={width}
          height={width}
          onError={setIsError}
        />
      )}
    </div>
  );
}

BrandLogo.propTypes = {
  type: PropTypes.string,
  width: PropTypes.string,
}.isRequired;

export default BrandLogo;
